import { render, staticRenderFns } from "./UsersPrivilegeClients.vue?vue&type=template&id=02a547a2&scoped=true&"
import script from "./UsersPrivilegeClients.vue?vue&type=script&lang=js&"
export * from "./UsersPrivilegeClients.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02a547a2",
  null
  
)

export default component.exports